import Quill from "quill";

export function setupQuill(
  element: HTMLElement,
  initialValue: string,
  onChange: (html: string) => void,
) {
  const quill = new Quill(element, {
    theme: "snow",
    placeholder: "Write the job description here...",
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],
    },
  });

  if (initialValue) {
    quill.root.innerHTML = initialValue;
  }

  quill.on("text-change", () => {
    // Get HTML content
    let html = quill.root.innerHTML;
    // If empty editor (Quill leaves <p><br></p>), treat as empty
    if (html === "<p><br></p>") {
      html = "";
    }
    onChange(html);
  });

  return quill;
}
